import * as v from "valibot";

import { rpcContract } from "../rpc";

export const submitWaitingListRpcContract = rpcContract({
  name: "submit-waiting-list",
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.email("Invalid email format")),
    name: v.pipe(v.string(), v.minLength(1, "Name is required"), v.maxLength(254)),
    handle: v.pipe(v.string(), v.minLength(3), v.maxLength(64)),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type SubmitWaitingListParams = v.InferOutput<(typeof submitWaitingListRpcContract)["paramsSchema"]>;
export type SubmitWaitingListResult = v.InferOutput<(typeof submitWaitingListRpcContract)["resultSchema"]>;
